/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Descriptions } from './descriptions';
import { EntityInfo } from './entityInfo';
import { HealthLevel } from './healthLevel';


export interface InventoryHealth { 
    /**
     * ID
     */
    id?: string | null;
    /**
     * Name of the component
     */
    name?: string | null;
    /**
     * Details about the health information
     */
    descriptions?: Array<Descriptions>;
    entity_info: EntityInfo;
    health_level: HealthLevel;
    /**
     * More indepth Details
     */
    internal_descriptions?: Array<string>;
    children: Array<InventoryHealth>;
}
export namespace InventoryHealth {
}


